import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestCadastroTerminal({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'terminal', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;
    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteCadastroTerminal({ payload }) {
  try {
    const { id, params } = payload;
    yield call(api.delete, `terminal/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));
    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { cadastroterminal, params } = payload;

    yield call(api.post, 'terminal', cadastroterminal);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/terminal');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;
    const { data } = yield call(api.get, `terminal/${id}`);
    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };
    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { cadastroterminal, params } = payload;
    yield call(api.put, 'terminal', cadastroterminal);
    yield put(successRemove({ ...params, pesquisalista: true }));
    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/terminal');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'terminal', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@cadastroterminal/CADASTROTERMINAL_IN_REQUEST',
    requestCadastroTerminal
  ),
  takeLatest(
    '@cadastroterminal/DELETE_CADASTROTERMINAL',
    deleteCadastroTerminal
  ),
  takeLatest('@cadastroterminal/SUCCESS_REMOVE', requestCadastroTerminal),
  takeLatest('@cadastroterminal/STORE_CADASTROTERMINAL', store),
  takeLatest('@cadastroterminal/FIND_CADASTROTERMINAL', find),
  takeLatest('@cadastroterminal/UPDATE_CADASTROTERMINAL', update),
  takeLatest('@cadastroterminal/RECORD_FILTERING', applyedFilters),
]);
